import { TYPOGRAPHY } from '../../../common/assets/styles';
import { MethodologyModal } from '../MethodologyModal';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

type Props = {
  className?: string;
};

export const DownloadMethodology: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Root type="button" onClick={() => setIsOpen(true)} className={className}>
        {t('common.downloadPDF')}
      </Root>
      <MethodologyModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

const Root = styled.button`
  ${TYPOGRAPHY.captionMedium12}
  color: var(--color9);
  background: none;
  border: 1px solid var(--color10);
  border-radius: 8px;
  padding: 6px 14px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;

  &:hover {
    color: var(--color2);
    border-color: var(--color2);
    background: var(--color14);
  }
  &:focus-visible {
    outline: 2px solid var(--color2);
    outline-offset: 2px;
  }
`;
